var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "#A7A7A7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone 13 mini - 5"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2361_110688)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -461,
    width: 375,
    height: 812,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 11464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319774"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: -15,
    y: -131,
    width: 327,
    height: 166,
    rx: 14,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 11475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quantity:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.21839 14C11.6226 14 14.3822 11.3137 14.3822 8C14.3822 4.68629 11.6226 2 8.21839 2C4.8142 2 2.05457 4.68629 2.05457 8C2.05457 11.3137 4.8142 14 8.21839 14Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.21838 4.5V8H11.8139",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2361_110688"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -461,
    width: 375,
    height: 812,
    rx: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlack);
export default __webpack_public_path__ + "static/media/clock_black.44fdeeef983e4218892042363680edf2.svg";
export { ForwardRef as ReactComponent };